import { Injectable, Inject } from '@angular/core';
import { environment } from '../../../environments/environment';
import { RegistrationUser } from '../index';

declare var AWSCognito: any;
declare var AWS: any;

export interface CognitoCallback {
    cognitoCallback(message: string, result: any): void;
}
export interface CognitoResendCallback {
    CognitoResendCallback(message: string, result: any): void;
}

export interface CognitoVerificationCallback {
    cognitoVerificationCallback(message: string, result: any): void;
}
export interface LoggedInCallback {
    isLoggedIn(message: string, loggedIn: boolean): void;
}

export interface ParameterCallback {
    callbackWithParam(result: any): void;
}

export interface Callback {
    callback(): void;
    callbackWithParam(result: any): void;
}

@Injectable()
export class CognitoUtil {

    public static _REGION = environment.region;

    public static _IDENTITY_POOL_ID = environment.identityPoolId;
    public static _USER_POOL_ID = environment.userPoolId;
    public static _CLIENT_ID = environment.clientId;

    // API Link
    public static _BACKEND_API_LINK = environment.backendapi;
    public static _POOL_DATA = {
        UserPoolId: CognitoUtil._USER_POOL_ID,
        ClientId: CognitoUtil._CLIENT_ID
    };


    public static getAwsCognito(): any {
        return AWSCognito;
    }

    getUserPool() {
        return new AWSCognito.CognitoIdentityServiceProvider.CognitoUserPool(CognitoUtil._POOL_DATA);
    }

    getCurrentUser() {
        return this.getUserPool().getCurrentUser();
    }


    getCognitoIdentity(): string {
        return AWS.config.credentials.identityId;
    }

    getAccessToken(): Promise<any> {
        return new Promise((resolve, reject) => {
            if (this.getCurrentUser() !== null) {
                this.getCurrentUser().getSession(function (err, session) {
                    if (err) {
                        console.log('CognitoUtil: Can\'t set the credentials:' + err);
                        reject(err);
                    } else {
                        if (session.isValid()) {
                            resolve(session.getAccessToken().getJwtToken());
                        } else {
                            reject({ message: 'CognitoUtil: Got the id token, but the session isn\'t valid' });
                        }
                    }
                });
            } else {
                reject({ message: 'No current user.' });
            }
        });
    }

    getAccessParameters(): Promise<any> {
        return new Promise((resolve, reject) => {
            // tslint:disable-next-line:prefer-const
            let cognitoUser = this.getCurrentUser();
            if (cognitoUser !== null) {
                cognitoUser.getSession(function (err, session) {
                    if (err) {
                        console.log('UserLoginService: Couldn\'t get the session: ' + err, err.stack);
                        reject({ message: err });
                    } else {
                        console.log('UserLoginService: Session is ' + session.isValid());
                        cognitoUser.getUserAttributes(function (errm, result) {
                            if (errm) {
                                reject({ message: errm });
                                console.log('UserParametersService: in getParameters: ' + errm);
                            } else {

                                resolve(result);
                            }
                        });
                    }
                });
            } else {
                reject({ message: 'No current user.' });
            }
        });
    }

    getIdToken(): Promise<any> {
        return new Promise((resolve, reject) => {
            if (this.getCurrentUser() != null) {
                this.getCurrentUser().getSession(function (err, session) {
                    if (err) {
                        console.log('CognitoUtil: Can\'t set the credentials:' + err);
                        reject(err);
                    } else {
                        if (session.isValid()) {
                            resolve(session.getIdToken().getJwtToken());
                        } else {
                            reject({ message: 'CognitoUtil: Got the id token, but the session isn\'t valid' });
                        }
                    }
                });
            } else {
                reject({ message: 'No current user.' });
            }
        });
    }

    getRefreshToken(callback: Callback): void {
        if (callback == null) {
            throw new Error(('CognitoUtil: callback in getRefreshToken is null...returning'));
        }
        if (this.getCurrentUser() != null) {
            this.getCurrentUser().getSession(function (err, session) {
                if (err) {
                    console.log('CognitoUtil: Can\'t set the credentials:' + err);
                    callback.callbackWithParam(null);
                } else {
                    if (session.isValid()) {
                        callback.callbackWithParam(session.getRefreshToken());
                    }
                }
            });
        } else {
            callback.callbackWithParam(null);
        }
    }

    refresh(): void {
        this.getCurrentUser().getSession(function (err, session) {
            if (err) {
                console.log('CognitoUtil: Can\'t set the credentials:' + err);
            } else {
                if (session.isValid()) {
                    console.log('CognitoUtil: refreshed successfully');
                } else {
                    console.log('CognitoUtil: refreshed but session is still not valid');
                }
            }
        });
    }
}



@Injectable()
export class UserRegistrationService {

    constructor(@Inject(CognitoUtil) public cognitoUtil: CognitoUtil) {

    }

    register(user: RegistrationUser, callback: CognitoCallback): void {
        console.log('UserRegistrationService: user is ' + user);

        // tslint:disable-next-line:prefer-const
        let attributeList = [];

        // tslint:disable-next-line:prefer-const
        let dataEmail = {
            Name: 'email',
            Value: user.email
        };
        // tslint:disable-next-line:prefer-const
        let dataFirstName = {
            Name: 'custom:firstname',
            Value: user.firstname
        };
        // tslint:disable-next-line:prefer-const
        let dataLastName = {
            Name: 'custom:lastname',
            Value: user.lastname
        };
        // tslint:disable-next-line:prefer-const
        let dataRole = {
            Name: 'custom:role',
            Value: 'seller'
        };

        attributeList.push(new AWSCognito.CognitoIdentityServiceProvider.CognitoUserAttribute(dataEmail));
        attributeList.push(new AWSCognito.CognitoIdentityServiceProvider.CognitoUserAttribute(dataFirstName));
        attributeList.push(new AWSCognito.CognitoIdentityServiceProvider.CognitoUserAttribute(dataLastName));
        attributeList.push(new AWSCognito.CognitoIdentityServiceProvider.CognitoUserAttribute(dataRole));

        this.cognitoUtil.getUserPool().signUp(user.email, user.password, attributeList, null, function (err, result) {
            if (err) {
                callback.cognitoCallback(err.message, null);
            } else {
                console.log('UserRegistrationService: registered user is ' + result);
                callback.cognitoCallback(null, result);
            }
        });

    }

    confirmRegistration(username: string, confirmationCode: string, callback: CognitoVerificationCallback): void {

        // tslint:disable-next-line:prefer-const
        let userData = {
            Username: username,
            Pool: this.cognitoUtil.getUserPool()
        };

        // tslint:disable-next-line:prefer-const
        let cognitoUser = new AWSCognito.CognitoIdentityServiceProvider.CognitoUser(userData);

        cognitoUser.confirmRegistration(confirmationCode, true, function (err, result) {
            if (err) {
                callback.cognitoVerificationCallback(err.message, null);
            } else {
                callback.cognitoVerificationCallback(null, result);
            }
        });
    }
    resendCode(username: string, callback: CognitoResendCallback): void {
        // tslint:disable-next-line:prefer-const
        let userData = {
            Username: username,
            Pool: this.cognitoUtil.getUserPool()
        };

        // tslint:disable-next-line:prefer-const
        let cognitoUser = new AWSCognito.CognitoIdentityServiceProvider.CognitoUser(userData);

        cognitoUser.resendConfirmationCode(function (err, result) {
            if (err) {
                callback.CognitoResendCallback(err.message, null);
            } else {
                callback.CognitoResendCallback(null, result);
            }
        });
    }

}

@Injectable()
export class UserLoginService {

    constructor(public cognitoUtil: CognitoUtil) {
    }

    authenticate(username: string, password: string, callback: CognitoCallback) {
        console.log("user: " + username + " - pass: " + password);
        console.log('UserLoginService: starting the authentication');
        // Need to provide placeholder keys unless unauthorised user access is enabled for user pool
        AWSCognito.config.update({ accessKeyId: 'anything', secretAccessKey: 'anything' });

        // tslint:disable-next-line:prefer-const
        let authenticationData = {
            Username: username,
            Password: password,
        };
        // tslint:disable-next-line:prefer-const
        let authenticationDetails = new AWSCognito.CognitoIdentityServiceProvider.AuthenticationDetails(authenticationData);

        // tslint:disable-next-line:prefer-const
        let userData = {
            Username: username,
            Pool: this.cognitoUtil.getUserPool()
        };

        console.log(authenticationDetails);
        console.log(userData);
        console.log('UserLoginService: Params set...Authenticating the user');
        // tslint:disable-next-line:prefer-const
        let cognitoUser = new AWSCognito.CognitoIdentityServiceProvider.CognitoUser(userData);
        console.log(cognitoUser);
        cognitoUser.authenticateUser(authenticationDetails, {
            onSuccess: function (result) {
                console.log("SUCCESS!!!!");
                // tslint:disable-next-line:prefer-const
                let logins = {};
                logins['cognito-idp.' + CognitoUtil._REGION + '.amazonaws.com/' +
                    CognitoUtil._USER_POOL_ID] = result.getIdToken().getJwtToken();

                // Add the User's Id Token to the Cognito credentials login map.
                AWS.config.credentials = new AWS.CognitoIdentityCredentials({
                    IdentityPoolId: CognitoUtil._IDENTITY_POOL_ID,
                    Logins: logins
                });

                console.log('UserLoginService: set the AWS credentials - ' + JSON.stringify(AWS.config.credentials));
                console.log('UserLoginService: set the AWSCognito credentials - ' + JSON.stringify(AWSCognito.config.credentials));
                callback.cognitoCallback(null, result);
            },
            onFailure: function (err) {
                console.log("ERROR!!!!");
                callback.cognitoCallback(err.message, null);
            },
        });
    }

    forgotPassword(username: string, callback: CognitoCallback) {
        // tslint:disable-next-line:prefer-const
        let userData = {
            Username: username,
            Pool: this.cognitoUtil.getUserPool()
        };

        // tslint:disable-next-line:prefer-const
        let cognitoUser = new AWSCognito.CognitoIdentityServiceProvider.CognitoUser(userData);

        cognitoUser.forgotPassword({
            onSuccess: function (result) {

            },
            onFailure: function (err) {
                callback.cognitoCallback(err.message, null);
            },
            inputVerificationCode() {
                callback.cognitoCallback(null, null);
            }
        });
    }

    confirmNewPassword(email: string, verificationCode: string, password: string, callback: CognitoCallback) {
        // tslint:disable-next-line:prefer-const
        let userData = {
            Username: email,
            Pool: this.cognitoUtil.getUserPool()
        };

        // tslint:disable-next-line:prefer-const
        let cognitoUser = new AWSCognito.CognitoIdentityServiceProvider.CognitoUser(userData);

        cognitoUser.confirmPassword(verificationCode, password, {
            onSuccess: function (result) {
                callback.cognitoCallback(null, result);
            },
            onFailure: function (err) {
                callback.cognitoCallback(err.message, null);
            }
        });
    }

    logout() {
        console.log('UserLoginService: Logging out');
        if(this.cognitoUtil.getCurrentUser() != null) {
            this.cognitoUtil.getCurrentUser().signOut();
        }
        else {
            console.log("Can not find a current user!");
        }

    }

    isAuthenticated(callback: LoggedInCallback) {
        if (callback == null) {
            throw new Error(('UserLoginService: Callback in isAuthenticated() cannot be null'));
        }
        // tslint:disable-next-line:prefer-const
        let cognitoUser = this.cognitoUtil.getCurrentUser();

        if (cognitoUser != null) {
            cognitoUser.getSession(function (err, session) {
                if (err) {
                    console.log('UserLoginService: Couldn\'t get the session: ' + err, err.stack);
                    callback.isLoggedIn(err, false);
                } else {
                    console.log('UserLoginService: Session is ' + session.isValid());
                    callback.isLoggedIn(err, session.isValid());
                }
            });
        } else {
            console.log('UserLoginService: can\'t retrieve the current user');
            callback.isLoggedIn('Can\'t retrieve the CurrentUser', false);
        }
    }

}

@Injectable()
export class UserParametersService {

    constructor(public cognitoUtil: CognitoUtil) {
    }

    getParameters(callback: ParameterCallback) {
        // tslint:disable-next-line:prefer-const
        let cognitoUser = this.cognitoUtil.getCurrentUser();

        if (cognitoUser != null) {
            cognitoUser.getSession(function (err, session) {
                if (err) {
                    console.log('UserParametersService: Couldn\'t retrieve the user');
                } else {
                    // tslint:disable-next-line:no-shadowed-variable
                    cognitoUser.getUserAttributes(function (err, result) {
                        if (err) {
                            console.log('UserParametersService: in getParameters: ' + err);
                        } else {
                            callback.callbackWithParam(result);
                        }
                    });
                }

            });
        } else {
            callback.callbackWithParam(null);
        }


    }
}
// @Injectable()
// export class CognitoService {

//   constructor() { }

// }



// WEBPACK FOOTER //
// ./src/app/authentication/service/cognito.service.ts